import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
class BodyMapService {
  static Create(bodyMap) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/bodymap/create`, bodyMap, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return ServiceHelper.IsEmptyGuid(response.data.data)
          ? null
          : response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Update(bodyMap) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/bodymap/update`, bodyMap, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "update");
        return ServiceHelper.IsEmptyGuid(response.data.data)
          ? null
          : response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Upload(bodyMap) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/bodymap/upload`, bodyMap, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "upload");
        return ServiceHelper.IsEmptyGuid(response.data.data)
          ? null
          : response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Get(id) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .get(`${envConfig.apiBaseUrl}/api/bodymap/get/${id}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Delete(id) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .delete(`${envConfig.apiBaseUrl}/api/bodymap/delete/${id}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }
}
export default BodyMapService;
